import { memo } from 'react';
import styled from '@emotion/styled';

import type { ThemeProps } from '@emotion/react';

import bp from '../../../../lib/cssMediaQuery';
import { useLiteSiteNav } from '../../../../lib/useNavLinks';
import MobileNavAndButton from './Mobile';
import DesktopLiteNav from './Desktop';

const defaultColors = {
  mobileNav: '#ffffff',
};

const MobileNavWrap = styled("span")`
  > div {
    overflow: visible;
    width: 100%;
    height: 60px;
    left: 0;
    top: 0;
    display: flex;

    background-color: ${({ theme }: ThemeProps): string =>
      theme.colors.background};

    > button {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 60px;
      cursor: pointer;
      border-radius: 4px;

      /* background: gray; */
      background: ${defaultColors.mobileNav};

      ${bp['max768']} {
        background: transparent;
      }

      span {
        overflow: hidden;
        text-indent: -1000px;
        background: transparent;
        width: 0;
      }

      span::before,
      span::after {
        left: 50%;
        margin-left: -21%;
      }
    }

    h2 {
    }

    ${bp['min768']} {
      display: none;
    }

    ${({ theme }: ThemeProps) => theme.liteSite?.Nav?.MobileNav}
  }
`;

function LiteNav() {
  const { pages, showNav } = useLiteSiteNav();

  if (!showNav) return null;

  return (
    <>
      <DesktopLiteNav />

      <MobileNavWrap>
        <MobileNavAndButton pages={pages} showMenuText />
      </MobileNavWrap>
    </>
  );
}

export default memo(LiteNav);
